import { render, staticRenderFns } from "./FeaturesMenu.vue?vue&type=template&id=8864bdd6&"
import script from "./FeaturesMenu.vue?vue&type=script&lang=js&"
export * from "./FeaturesMenu.vue?vue&type=script&lang=js&"
import style0 from "./FeaturesMenu.vue?vue&type=style&index=0&id=8864bdd6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports